import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AlertComponent } from './core/components/alert/alert.component';
import { ConfirmationComponent } from './core/components/confirmation/confirmation.component';

@Component({
  selector: 'peca-root',
  template: `
    <router-outlet />
    <peca-confirmation />
    <peca-alert />
  `,
  imports: [RouterModule, ConfirmationComponent, AlertComponent],
})
export class AppComponent {}
